module.exports = __webpack_public_path__ + "img/colaborador-jacques.29b6384a.jpeg";